import { useCallback } from 'react'
import { load } from '../environments'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useAppVars() {
  return useCallback(() => load(), [])
}